html, body {
  height: 100%;
}

body {
  margin: 0;
  color: var(--pds-color-text-primary);
  background-color: var(--pds-color-grey-100);
}

#root {
  min-height: 100%;
}

a:not(.pds-button) {
  color: var(--pds-color-text-primary);
  text-decoration: underline;
}
a:not(.pds-button):hover {
  color: var(--pds-color-text-secondary);
}
